import KatalLogger, { Level } from "@amzn/katal-logger";

const katalLoggerConfig = {
    url: "{{KatalLoggerUrl}}",
    logThreshold: Level.INFO,
    maxLogLineSize: 10000,
    logToConsole: true,
};

export const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();